export default __webpack_public_path__ + "static/media/leaf.305efe6c.png";